import { EyeOutlined } from "@ant-design/icons"
import { Image as AntdImage, type ImageProps } from "antd"
import { Spinner } from "components/Spinner/Spinner"
import { cn } from "styles/cn"

export const Image = ({
	className,
	rootClassName,
	classNames,
	preview = false,
	placeholder = <Spinner />,
	...props
}: ImageProps) => {
	const customClassNames =
		typeof classNames === "object" && classNames !== null
			? classNames
			: undefined

	return (
		<AntdImage
			{...props}
			rootClassName={cn("h-full", rootClassName)}
			className={cn("size-full object-contain", className)}
			preview={
				typeof preview === "boolean" && !!preview
					? {
							cover: <EyeOutlined aria-hidden />,
						}
					: preview
			}
			classNames={{
				...customClassNames,
				cover: cn("rounded-md", customClassNames?.cover),
				popup: {
					...customClassNames?.popup,
					root: cn("size-full", customClassNames?.root),
				},
			}}
			placeholder={placeholder}
		/>
	)
}
